export default "https://cdn-static.gokick.com/assets/672a5c69b0b224f66a9a6ac0576938eca42c1cee/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";